import { render, staticRenderFns } from "./DeviceConfig.vue?vue&type=template&id=0c9d133a&scoped=true"
import script from "./DeviceConfig.vue?vue&type=script&lang=js"
export * from "./DeviceConfig.vue?vue&type=script&lang=js"
import style0 from "./DeviceConfig.vue?vue&type=style&index=0&id=0c9d133a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d133a",
  null
  
)

export default component.exports